import { Component } from '@angular/core';
import { Subscription} from "rxjs";
import {GameService} from "../../../../services/game.service";
import {Game} from "../../../../models/game.class";

@Component({
  selector: 'app-recent',
  templateUrl: './recent.component.html',
  styleUrls: ['./recent.component.scss']
})
export class RecentComponent {

  recentGames: Game[] = [];
  gamesSubs?: Subscription;
  //separate subscription for favourites because we dont want the random carousel to change each time when favourites change
  favouriteIds: number[] = [];
  favouritesSubs?: Subscription;

  randomGamesForCarousel: Game[] = [];

  constructor(
    private gameService: GameService
  ) {
    this.gamesSubs = this.gameService.getGames().subscribe(games=>{
      if (games.length){
        this.recentGames = this.gameService.getRecentGames(games);
        this.randomGamesForCarousel = this.gameService.pickRandomGames(games.all, 16);
      }
    })
  }

  ngOnInit(){
    this.favouritesSubs = this.gameService.favouriteGameIds$.subscribe(favouriteIds => {
      this.favouriteIds = favouriteIds
    })
  }


  ngOnDestroy(){
    this.gamesSubs?.unsubscribe();
    this.favouritesSubs?.unsubscribe();
  }

}
